<template>
  <div class="admin-layout min-h-screen bg-gray-50 dark:bg-gray-900 transition-colors duration-200">
    <!-- Mobile Sidebar Overlay -->
    <div
      v-if="isMobileOpen"
      class="fixed inset-0 bg-black/50 z-40 lg:hidden print:hidden"
      @click="closeMobileSidebar"
    />

    <!-- Sidebar -->
    <Sidebar
      :is-collapsed="isCollapsed"
      :is-mobile-open="isMobileOpen"
      @close-mobile="closeMobileSidebar"
    />

    <!-- Main Content -->
    <div
      class="transition-all duration-300 print:!ml-0"
      :class="[
        isCollapsed ? 'lg:ml-16' : 'lg:ml-64',
        'ml-0'
      ]"
    >
      <!-- Header -->
      <Header
        :is-collapsed="isCollapsed"
        class="print:hidden"
        @toggle-sidebar="toggleSidebar"
        @open-mobile-sidebar="openMobileSidebar"
      />

      <!-- Page Content -->
      <main class="p-2 md:p-4 lg:p-6 pt-10 lg:pt-12 min-h-[calc(100vh-4rem)]">
        <RouterView />
      </main>

      <!-- Footer -->
      <footer class="py-4 px-4 lg:px-6 bg-gray-50 dark:bg-gray-900 border-t border-gray-200 dark:border-gray-700 print:hidden">
        <p class="text-center text-sm text-gray-500 dark:text-gray-400">
          © 2026 Achiraya Studio. All rights reserved.
        </p>
      </footer>
    </div>
  </div>
</template>

<script setup lang="ts">
import Sidebar from './Sidebar.vue'
import Header from './Header.vue'
import { useSidebar } from '../../composables/useSidebar'

const { isCollapsed, isMobileOpen, toggleSidebar, closeMobileSidebar, openMobileSidebar } = useSidebar()
</script>
